export default "__VITE_ASSET__CpUdtlNO__"